import { hasValue } from "./data";
import { naOrdemDaLinha } from "./fluxoExecutivo";
import { F } from "./gerencialFields";

// Marcos do fluxo, na ordem em que acontecem na fábrica.
// "campo" é a coluna da planilha que registra a CONCLUSÃO da etapa.
// Apenas campos reais (operador digitou) — fórmulas WORKDAY (BG, BX, CO)
// não entram aqui.
const ETAPAS = [
  { key: "pedido", titulo: "Pedido gerado", campo: F.DATA_DA_VENDA },
  { key: "liberacao", titulo: "Liberação da obra", campo: F.LIBERACAO_DA_OBRA },
  { key: "acabamentos", titulo: "Definição de acabamentos", campo: F.DEFINICAO_ACABAMENTOS_REALIZADO },
  { key: "medicao", titulo: "Medição", campo: F.MEDICAO_REALIZADO },
  { key: "executivo", titulo: "Projeto executivo", campo: F.EXECUTIVO_REALIZADO },
  // Ordem nova; a linha da ordem antiga troca as duas (utils/fluxoExecutivo).
  { key: "revisao", titulo: "Revisão", campo: F.REVISAO },
  { key: "aprovacao", titulo: "Aprovação do executivo", campo: F.APROVACAO_DO_EXECUTIVO },
  { key: "otimizacao", titulo: "Otimização de lote", campo: F.OTIMIZACAO_DO_LOTE },
  { key: "compras", titulo: "Compras (MDF/Bordo)", campo: F.MDF_BORDO },
  { key: "corte", titulo: "Corte", campo: F.DATA_DE_CORTE },
  { key: "bordo", titulo: "Bordo", campo: F.DATA_DE_BORDO },
  { key: "usinagem", titulo: "Furação e usinagem", campo: F.DATA_DE_USINAGEM, extraCampo: F.DATA_DE_FURACAO },
  { key: "marcenaria-inicio", titulo: "Marcenaria iniciada", campo: F.MARCENARIA_INICIO },
  { key: "marcenaria-fim", titulo: "Marcenaria finalizada", campo: F.MARCENARIA_TERMINO },
  { key: "acabamento", titulo: "Acabamentos", campo: F.ACABAMENTO_REALIZADO },
  { key: "carregamento", titulo: "Carregamento", campo: F.CARREGAMENTO },
];

const ORDEM_DO_EXECUTIVO = {
  ehRevisao: (etapa) => etapa.key === "revisao",
  ehAprovacao: (etapa) => etapa.key === "aprovacao",
};

function isEtapaConcluida(row, etapa) {
  if (etapa.extraCampo) {
    return hasValue(row[etapa.campo]) && hasValue(row[etapa.extraCampo]);
  }
  return hasValue(row[etapa.campo]);
}

// Para pedidos legados sem REVISAO digitada mas com OTIMIZACAO_DO_LOTE
// preenchida, considera a revisão implícita (mesma convenção de clientes.jsx).
function isRevisaoImplicita(row, etapaKey) {
  return etapaKey === "revisao" && !hasValue(row[F.REVISAO]) && hasValue(row[F.OTIMIZACAO_DO_LOTE]);
}

export function buildAmbienteEtapas(row) {
  if (!row) {
    return [];
  }

  const etapasComConclusao = naOrdemDaLinha(row, ETAPAS, ORDEM_DO_EXECUTIVO).map((etapa) => ({
    ...etapa,
    concluida: isEtapaConcluida(row, etapa) || isRevisaoImplicita(row, etapa.key),
    implicita: isRevisaoImplicita(row, etapa.key) && !isEtapaConcluida(row, etapa),
    data: row[etapa.campo] ?? null,
  }));

  const primeiraPendente = etapasComConclusao.findIndex((e) => !e.concluida);

  return etapasComConclusao.map((etapa, index) => {
    let status;
    if (primeiraPendente === -1) {
      status = "concluida";
    } else if (index < primeiraPendente) {
      status = "concluida";
    } else if (index === primeiraPendente) {
      status = "atual";
    } else {
      status = "futura";
    }

    return {
      key: etapa.key,
      titulo: etapa.titulo,
      campo: etapa.campo,
      data: etapa.data,
      status,
      implicita: etapa.implicita,
    };
  });
}
